var map = {
	"./plain-sticker-a.png": 97,
	"./plain-sticker-b.png": 98,
	"./plain-sticker-c.png": 99,
	"./plain-sticker-d.png": 100,
	"./plain-sticker-e.png": 101,
	"./plain-sticker-f.png": 102,
	"./plain-sticker-g.png": 103,
	"./plain-sticker-h.png": 104,
	"./plain-sticker-i.png": 105,
	"./plain-sticker-j.png": 106,
	"./plain-sticker-k.png": 107,
	"./plain-sticker-l.png": 108,
	"./plain-sticker-m.png": 109,
	"./plain-sticker-n.png": 110,
	"./plain-sticker-o.png": 111,
	"./plain-sticker-p.png": 112,
	"./plain-sticker-q.png": 113,
	"./plain-sticker-r.png": 114,
	"./plain-sticker-s.png": 115,
	"./plain-sticker-t.png": 116,
	"./plain-sticker-u.png": 117,
	"./plain-sticker-v.png": 118,
	"./plain-sticker-w.png": 119,
	"./plain-sticker-x.png": 120,
	"./plain-sticker-y.png": 121,
	"./plain-sticker-z.png": 122
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 469;